// extracted by mini-css-extract-plugin
export default {"root":"KIwsJjfW7kIoR4rush7Q","layout-action":"VmJniiJyCCjmKbpG5DKC","layout-action__content":"sKQKaNdzekNHdQra31Nb"};